export const FLAG_POLICIES_INSUREDS_CSV_EXPORT =
  "feature_flag_policies_insureds_csv_export";

export const FLAG_COI_POLICY_PICKER = "feature_flag_coi_policy_picker";

// CSR-2326 — gates the AOR (customer moved agency) experience: the flag/restore
// routes and every AOR surface in the UI. Default OFF until the DC AOR columns
// (CSR-2323/2324/2325) are released in the environment.
export const FLAG_AOR_EXPERIENCE = "feature_flag_aor_experience";
